// axios
import axios from 'axios'
import { BASE_URL, UPLOAD_URL, DOWNLOAD_URL } from '../config/constants'
import store from '../store'
import errorCode from './errorCode.js'
import router from "@/router";

axios.defaults.baseURL = BASE_URL
axios.defaults.timeout = 30000

axios.interceptors.request.use((config) => {
	config.headers['accessToken'] = store.state.token
  config.headers['pg'] = "com.miguan.dxjzsjb"
  config.headers['n-cid'] = "pc"
	return config
}, (error) => {
	return Promise.reject(new Error(error.message))
})

axios.interceptors.response.use((response) => {
	const code = response.data.code;
	if(code){
		let data = errorCode(response.data)
		if (data) {
			return data
		}
	}else{
		return response.data
	}



	return Promise.reject()

}, (error) => {
	return Promise.reject(error.message)
})

export default {
	axios,
	BASE_URL,
	UPLOAD_URL,
	DOWNLOAD_URL,
	post: (url = '') => {
		return (data = {}, config = {}) => {
			return axios.post(url, data, config)
		}
	},
	get: (url = '') => {
		return (data = {}, config = {}) => {
			return axios.get(url, { params: data }, config)
		}
	},
	detail: (url = '') => {
		return (id = '', config = {}) => {
			return axios.get(url+'/'+id, config)
		}
	},
	link: (url = '') => {
		return (data = {}) => {
			data.accessToken=store.state.token
			var params = Object.keys(data).map(function(key) {
				if(data[key]){
					return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
				}else{
					return ''
				}
			}).join("&");
			window.location.href = BASE_URL + url + "?" + params
		}
	},
	downloadExcel: (url = '') => {
		return (data = {}, config = {}) => {
			return axios.request({
			  url: url,
			  method: 'get',
			  data:data,
			  responseType:'blob'
			})
		}
	},
  //退出登录后到未登录首页
	redirectToLogin: () => {
		router.replace('/login').catch(() => {})
	},
	redirectToHomepage: () => {
		router.replace('/hometoc').catch(() => {})
	}
}
